(function () {
  'use strict';

  function ready() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS !== 'object') return;

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.html || !data.sectionId) return;
      var id = 'VhPriceExtras-' + data.sectionId;
      var dest = document.getElementById(id);
      if (!dest) return;
      var src = data.html.getElementById(id);
      if (!src) return;
      dest.innerHTML = src.innerHTML;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
